import { Injectable } from '@angular/core';
import { ShareMode } from '@shared/config/navigation.config';
import { Contact } from '@shared/models';
import { GraphApiContact } from '@shared/models/graph-api.model';
import { Observable } from 'rxjs';
import { shareReplay, switchMap } from 'rxjs/operators';
import { GraphApiHttpService } from './graph-api-http.service';

@Injectable({
  providedIn: 'root',
})
export class GraphApiService {
  public me$: Observable<GraphApiContact> = this.getProfile();

  constructor(private graphHttp: GraphApiHttpService) {}

  private getProfile(): Observable<GraphApiContact> {
    return this.graphHttp.getProfile().pipe(shareReplay(1));
  }

  public getUsers(
    shareMode: ShareMode,
    name?: string,
    top: number = 20
  ): Observable<Contact[]> {
    return this.me$.pipe(
      switchMap(me => this.graphHttp.getUsers(shareMode, name, top, me.id))
    );
  }

  public getGroupsAndMeetingsByName(
    name: string,
    top: number = 20
  ): Observable<Contact[]> {
    return this.me$.pipe(
      switchMap(me =>
        this.graphHttp.getGroupsAndMeetingsByName(name, top, me.displayName)
      )
    );
  }

  public createOneToOneChat(contact: Contact): Observable<any> {
    return this.me$.pipe(
      switchMap(me => this.graphHttp.createOneToOneChat(contact, me.id))
    );
  }
}
